export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    likeBetter: null,
    beverageLikeBetter: null,
    feelBloated: null,
  },
})
